import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

const ErrorMessage = ({ message }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiAlertTriangle} className="text-red-500" />
        <span className="text-red-800 font-medium">Error</span>
      </div>
      <p className="text-red-700 mt-1">{message}</p>
      <p className="text-red-600 text-sm mt-2">
        Please ensure location services are enabled in your browser settings.
      </p>
    </div>
  );
};

export default ErrorMessage;